    import React from 'react';
    import { ToastContainer, toast, Bounce } from 'react-toastify';
    import 'react-toastify/dist/ReactToastify.css';

    const Notification = () => {
      return (
        <ToastContainer
          position="bottom-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover
          theme="dark"
          transition={Bounce}
        />
      );
    };

    export const notifyInfo = (message) => {
      toast.info(message, {
        position: "bottom-right",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        className: "custom-toast-info",
      });
    };

    export const notifySuccess = (message) => {
      toast.success(message, {
        position: "bottom-right",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        pauseOnFocusLoss: false,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        className: "custom-toast-success",
      });
    };

    export const notifyWarning = (message) => {
      toast.warn(message, {
        position: "bottom-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    };

    export const notifyError = (message) => {
      toast.error(message, {
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    };

    export default Notification;